import * as tslib_1 from "tslib";
import { DetailAccountModel, DetailRevolvingCreditModel, PcoModel, ProductCard, } from 'src/app/shared/models/abre-cuentas.model';
import { BANK_INFO_CONST, BUSINESS_CONST } from '../../constants/business.constants';
import { RISK_LEVELS } from '../../constants/rate.constants';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { HelpersService } from '../helpers/helpers-onboarding.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { StringHelperService } from '../helpers/string-helper.service';
import { ValidationHelperService } from '../helpers/validation-helper.service';
import { ParametersService } from '../parameters/parameters.service';
import { RequestService } from '../request/request-onboarding.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { CHANNEL } from '../../constants/channel.constants';
import { LogDeviceModel } from '../../models/log-device.model';
import { CryptoVaultService } from '../external/crypto-vault/crypto-vault.service';
import { ERROR_LIB } from '../../constants/abre-cuentas.constants';
// import { NavigationService } from '../navigation/navigation-onboarding.service';
import { OpEnum } from '../../enums/op.enum';
import * as i0 from "@angular/core";
import * as i1 from "../request/request-onboarding.service";
import * as i2 from "../abre-cuentas/abre-cuentas.service";
import * as i3 from "../helpers/validation-helper.service";
import * as i4 from "../helpers/helpers-onboarding.service";
import * as i5 from "../helpers/string-helper.service";
import * as i6 from "../firmly-approved/firmly-approved.service";
import * as i7 from "../parameters/parameters.service";
import * as i8 from "../communicator/channel-communicator/channel-communicator.service";
import * as i9 from "../external/crypto-vault/crypto-vault.service";
/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var CaptureService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @param {RequestService}             requestService
     * @param {AbreCuentasService}         abreCuentasService
     *
     */
    function CaptureService(requestService, abreCuentasService, validationHelperService, helperService, stringHelperService, firmlyApprovedService, parametersService, channel, channelCommunicatorService, cipherService) {
        this.requestService = requestService;
        this.abreCuentasService = abreCuentasService;
        this.validationHelperService = validationHelperService;
        this.helperService = helperService;
        this.stringHelperService = stringHelperService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.parametersService = parametersService;
        this.channel = channel;
        this.channelCommunicatorService = channelCommunicatorService;
        this.cipherService = cipherService;
        this.credit_recharge_up_information = [];
        this.priority = 0;
        this.solicitationId = this.abreCuentasService.getSolicitationId();
        this.variableForControlCall = 0;
    }
    /**
     * Función asíncrona para enviar la información de la ocupacion del cliente
     *
     * *Async Function that sends occupation client info*
     *
     * @type {function}
     * @returns {Promise}
     */
    CaptureService.prototype.sendProspectOccupation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, parms, selectedAgreement;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                body = {
                    occupation_id: 1,
                    ciiu: '010',
                    product_type: 'NOMINA',
                    benefit_code: 'NODEFINIDO',
                };
                parms = {
                    main_activity_id: 1,
                    first_name: this.abreCuentasService.getDocumentInfo().firstname,
                    first_surname: this.abreCuentasService.getDocumentInfo().primary_lastname,
                    product_type: 'NOMINA',
                    benefit_code: 'NODEFINIDO',
                };
                selectedAgreement = this.abreCuentasService.getAgreementSelected();
                if (selectedAgreement.transaction_type === 'true') {
                    body.benefit_code = 'USAYNOPAGUES';
                    parms.benefit_code = 'USAYNOPAGUES';
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectOccupation(body, parms)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    CaptureService.prototype.maProduct = function (requestData, product) {
        var _this = this;
        this.creditGrayZone = this.parametersService.getSetting('creditGrayZone');
        var responsebool = false;
        try {
            var isData = requestData.product.data.map(function (element) {
                return {
                    data: element.products.find(function (e) { return e.product_type === product; }),
                    status: {
                        phase: element.solicitation_phase,
                        status: element.solicitation_status,
                    },
                };
            });
            isData.forEach(function (element) {
                if (_this.creditGrayZone.find(function (elements) {
                    return elements.phase === element.status.phase &&
                        elements.status === element.status.status;
                })) {
                    responsebool = true;
                }
            });
            return responsebool;
        }
        catch (error) {
            return responsebool;
        }
    };
    /**
     * Función asíncrona para enviar la información de ocupación
     * independiente del cliente
     *
     * *Async Function that sends independent occupation client info*
     *
     * @type {function}
     * @param {CiiuModel} occupation
     * @returns {Promise}
     */
    CaptureService.prototype.sendProspectIndependentOccupation = function (occupation) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectIndependentOccupation(occupation)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    CaptureService.prototype.sendProspectIncomeForm = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectIncomeForm(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de ocupación del cliente
     *
     * *Async Function that sends occupation client info*
     *
     * @type {function}
     * @param {string} body
     * @returns {Promise}
     */
    CaptureService.prototype.sendProspectOccupationWithBody = function (body, parms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectOccupation(body, parms)
                            .then(function (res) {
                            var response = {
                                status: res.status,
                                body: res.body.data,
                            };
                            resolve(response);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de contacto del cliente
     *
     * *Async Function that sends contact client info*
     *
     * @type {function}
     * @param {string} contact
     * @returns {Promise}
     */
    CaptureService.prototype.sendProspectOccupationUbicationInfo = function (contact) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.requestService
                                        .sendProspectContact(contact)
                                        .then(function (res) { return resolve(res); })
                                        .catch(function (err) { return reject(err); })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información del tipo de operación
     *
     * *Async Function that sends operation currency info*
     *
     * @type {function}
     * @param {string} contact
     * @returns {Promise}
     */
    CaptureService.prototype.sendProspectOperationCurrency = function (operationCurrencyList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectOperationCurrency(operationCurrencyList)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información del porductos moneda extranjera
     *
     * *Async Function that sends foreign currency products*
     *
     * @type {function}
     * @param {string} productInfo
     * @returns {Promise}
     */
    CaptureService.prototype.sendProspectForeignCurrencyProducts = function (productInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectForeignCurrencyProducts(productInfo)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función guardar información de la ciudad de nacimiento
     *
     * *Function that saves birthplace prospect*
     *
     * @param {any} data
     */
    CaptureService.prototype.sendProspectBirthplace = function (city) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.requestService.sendProspectBirthplace(city)];
            });
        });
    };
    /**
     * Función guardar información de la ciudad y dirección de la oficina
     *
     * *Function that saves office address*
     *
     * @param {any} body
     */
    CaptureService.prototype.sendProspectOfficeAddress = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectOfficeAddress(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función guardar información financiera
     *
     * *Function that saves financial info*
     *
     * @param {any} body
     */
    CaptureService.prototype.sendProspectFinancial = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectFinancial(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Funcion que desacopla los ternarios y evita el branching en los test.
     * @param variable variable a evaluar
     * @param defaultValue valor por defecto a retornar si la variable es undefined
     */
    CaptureService.prototype.getValueWithOutUndefined = function (variable, defaultValue) {
        return variable !== undefined ? variable : defaultValue;
    };
    CaptureService.prototype.getOTP = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .getOTP(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona que valida el codigo otp
     *
     * *Async Function that validate the otp code*
     *
     * @type {function}
     * @param {any} body
     */
    CaptureService.prototype.validateOTP = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .validateOTP(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de ocupación
     * independiente del cliente
     *
     * *Async Function that sends independent occupation client info*
     *
     * @type {function}
     * @param {CiiuModel} occupation
     * @returns {Promise}
     */
    CaptureService.prototype.sendPostTermsAndConditions = function (devicePrint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectIndependentOccupation(devicePrint)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    CaptureService.prototype.buildClientBody = function (data) {
        var codePCO = '';
        var civilStatus;
        var socialClassType = '';
        var housingTypePersonal = '';
        var ethnicGroup;
        var isUserJemelii = this.abreCuentasService.getUserJemelii();
        civilStatus =
            data.marital_status_code !== undefined ? data.marital_status_code : '';
        ethnicGroup =
            data.ethnic_group_code !== undefined ? data.ethnic_group_code : '';
        socialClassType = data.address !== undefined ? data.address.stratum : '';
        housingTypePersonal =
            data.address !== undefined ? data.address.housingType.housingId : '';
        if ((data.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
            data.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            data.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            data.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) &&
            !(!this.firmlyApprovedService.isEmpty() &&
                this.firmlyApprovedService.getOfferType_Channel() === 'En_firme')) {
            codePCO = data.solicitation_status.status_code.replace('PCO', '');
        }
        var pep_questions;
        if (this.validationHelperService.isPassiveProduct() ||
            (!this.firmlyApprovedService.isEmpty() &&
                this.firmlyApprovedService.getOfferType_Channel() === 'En_firme')) {
            pep_questions = {
                pep_questions: [
                    {
                        question_id: '1',
                        answer: data.IsPEP !== undefined ? data.IsPEP.elementId === 1 : '',
                        justification: 'N/A',
                    },
                ],
            };
        }
        var birthdate = data.birthdate.toString();
        var birthdateArr = birthdate.split('/');
        if (birthdateArr[0].length !== 4) {
            birthdate = birthdateArr.reverse().join('-');
        }
        var body = tslib_1.__assign({ document: {
                type: data.product_type == BUSINESS_CONST.PRODUCT_TYPE_LIVING
                    ? data.document_type
                    : this.validationHelperService.filterDocumentType(data.document_type),
                number: data.document_number,
                date_of_issue: data.date_of_issue
                    .toString()
                    .split('/')
                    .reverse()
                    .join('-'),
            }, given_names: [data.firstname, data.middlename || ''], first_surname: data.primary_lastname, second_surname: data.second_lastname, gender: data.isPostlogin &&
                data.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING
                ? data.sex
                : data.sex, education_level: null, birthdate: birthdate, birth_place: (data.bp_province_code
                ? data.bp_province_code
                : data.province_code || '') +
                (data.bp_city_code ? data.bp_city_code : data.city_code || ''), nationality: 'COL', is_client: isUserJemelii ? false :
                data.isPostlogin &&
                    data.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING
                    ? data.isPostlogin
                    : false, agreement_code: '', social_class: socialClassType ? socialClassType : '', housing_type: housingTypePersonal ? housingTypePersonal : '', format_required: data.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                data.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                data.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
                data.product_type === BUSINESS_CONST.MULTI, is_was_client: isUserJemelii ? false : this.abreCuentasService.getPostlogin(), manager: {
                manager_id: data.advisorCheck === '1' ? data.advisorCode : '',
            }, marital_status: civilStatus ? civilStatus : '', ethnic_group: ethnicGroup ? ethnicGroup : '', solicitation_status: {
                status_code: codePCO,
                status_description: '',
            } }, pep_questions, { branch_code: data.isPostlogin &&
                data.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING
                ? data.originator_branch
                    .toString()
                    .replace(/^(\d{1})$/g, '00$1')
                    .replace(/^(\d{2})$/g, '0$1')
                : data.agency_code, update_client: data.updateClient, restrictive_status: data.list_query_status
                ? data.list_query_status.status_code
                : '' });
        if (!this.firmlyApprovedService.isEmpty() &&
            this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
            body.role = '1';
        }
        console.warn('///** IS CLIENT ' + body.is_client + '  -- WAS_CLIENT ' + body.is_was_client);
        console.warn('Body ajustado: ', body);
        var issuedExpedition = {
            city: data.issued_city,
            department: data.issued_department,
        };
        if (issuedExpedition.city &&
            issuedExpedition.city !== '' &&
            issuedExpedition.department &&
            issuedExpedition.department !== '') {
            body['issued_city'] = this.validationHelperService.filterCityByNames(issuedExpedition.city, issuedExpedition.department);
        }
        return body;
    };
    CaptureService.prototype.createClient = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, birthplaceInfo, fiModel, agencySelected, 
            // tslint:disable-next-line: no-shadowed-variable
            ContactModel, maritalStatusModel, ethnicGroupInfo, pcoModel, isPostlogin, basicModel, advisorCheck, updateClient, ProspectResponse, documentModel, advisorCode, product_type, data, body, _b, basicInfoSecondHeadlineModel, fiSecondHeadlineModel, contactSecondHeadlineModel, maritalStatusSecondHeadlineModel, ProspectResponseSecondHeadLine, name_1, dataSecond, res, solicitationId;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.abreCuentasService.getAbreCuentasModel(), birthplaceInfo = _a.birthplaceInfo, fiModel = _a.fiModel, agencySelected = _a.agencySelected, ContactModel = _a.ContactModel, maritalStatusModel = _a.maritalStatusModel, ethnicGroupInfo = _a.ethnicGroupInfo, pcoModel = _a.pcoModel, isPostlogin = _a.isPostlogin, basicModel = _a.basicModel, advisorCheck = _a.advisorCheck, updateClient = _a.updateClient, ProspectResponse = _a.ProspectResponse, documentModel = _a.documentModel, advisorCode = _a.advisorCode;
                        product_type = this.abreCuentasService.getproductSelected().product_type;
                        data = tslib_1.__assign({}, birthplaceInfo, fiModel, agencySelected, ContactModel, maritalStatusModel, ethnicGroupInfo, documentModel, { product_type: product_type }, pcoModel, basicModel, ProspectResponse, { advisorCheck: advisorCheck,
                            updateClient: updateClient,
                            isPostlogin: isPostlogin,
                            advisorCode: advisorCode });
                        body = this.buildClientBody(data);
                        console.warn('Create Client >>>> Body: ', body);
                        if (!this.validationHelperService.isPassiveProduct()) {
                            body = {
                                clients: [
                                    tslib_1.__assign({}, body),
                                ],
                            };
                            if (this.abreCuentasService.getproductSelected().product_type ===
                                BUSINESS_CONST.PRODUCT_TYPE_LIVING &&
                                typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                                this.abreCuentasService.getSecondHeadline().has_second_headline) {
                                _b = this.abreCuentasService.getAbreCuentasModel(), basicInfoSecondHeadlineModel = _b.basicInfoSecondHeadlineModel, fiSecondHeadlineModel = _b.fiSecondHeadlineModel, contactSecondHeadlineModel = _b.contactSecondHeadlineModel, maritalStatusSecondHeadlineModel = _b.maritalStatusSecondHeadlineModel, ProspectResponseSecondHeadLine = _b.ProspectResponseSecondHeadLine;
                                name_1 = this.validationHelperService.splitNames(basicInfoSecondHeadlineModel.name_second_headline, basicInfoSecondHeadlineModel.lastname_second_headline);
                                dataSecond = tslib_1.__assign({}, contactSecondHeadlineModel, maritalStatusSecondHeadlineModel, pcoModel, agencySelected, fiSecondHeadlineModel, ProspectResponseSecondHeadLine, { advisorCheck: advisorCheck,
                                    isPostlogin: isPostlogin,
                                    advisorCode: advisorCode,
                                    product_type: product_type, document_type: this.validationHelperService.filterDocumentType(basicInfoSecondHeadlineModel.doc_type_second_headline.toString()), document_number: basicInfoSecondHeadlineModel.doc_number_second_headline, date_of_issue: basicInfoSecondHeadlineModel.expeditiondate_second_headline, firstname: name_1.firstname, middlename: name_1.middlename, primary_lastname: name_1.primary_lastname, second_lastname: name_1.second_lastname, birthdate: basicInfoSecondHeadlineModel.birthdate_second_headline, province_code: '', city_code: '', updateClient: false, issued_city: '', issued_department: '', gender: basicInfoSecondHeadlineModel.gender_second_headline, sex: basicInfoSecondHeadlineModel.gender_second_headline, agency_code: '' });
                                res = this.buildClientBody(dataSecond);
                                console.warn('Create Client >>>> Body: ', res);
                                body.clients.push(res);
                            }
                            /* updateClient = false; */
                        }
                        if (this.channel.getChannelId() === '159') {
                            body.identification_analysis_ind =
                                this.abreCuentasService.getflagGreyZone();
                        }
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .createClient({ data: body }, solicitationId)
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    console.error(error);
                                    throw 500;
                                }
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    CaptureService.prototype.buildAddressesBody = function (self, type_address) {
        return {
            type: type_address,
            street: self.address.address,
            city: (self.address.city.province_code || '') + self.address.city.city_code,
            district: (self.address.city.province_code || '') + '',
            country: 'COL',
            fiscal_country: 'COL',
            alternative_country: 'COL',
        };
    };
    CaptureService.prototype.prospectAddresses = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var self, body, res, _a, occupationSelected, ContactModel_1, addressResidence, addressOffice, residenceCity, laboralCity, occupation, ciiu, bodySecondHeadline, dataSecondHeadline, secondData;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        body = {
                            data: {
                                addresses: [],
                            },
                        };
                        if (this.abreCuentasService.getPostlogin() &&
                            this.abreCuentasService.getproductSelected().product_type !==
                                BUSINESS_CONST.PRODUCT_TYPE_LIVING && (!type || type == 'PARTICULAR')) {
                            _a = this.abreCuentasService.getAbreCuentasModel(), occupationSelected = _a.occupationSelected, ContactModel_1 = _a.ContactModel;
                            addressResidence = ContactModel_1.address;
                            addressOffice = this.abreCuentasService.getOfficeInfo(occupationSelected.id.toString()).address;
                            if (addressResidence) {
                                residenceCity = addressResidence.city;
                                (self = {
                                    address: {
                                        address: addressResidence.address ? addressResidence.address : '',
                                        city: {
                                            province_code: (residenceCity.province_code || '') + '',
                                            city_code: residenceCity.city_code,
                                        },
                                    },
                                }),
                                    (res = this.buildAddressesBody(self, 'PARTICULAR'));
                                body.data.addresses.push(res);
                            }
                            if (addressOffice &&
                                this.abreCuentasService.getCiiuSelected().ciiu !== '090') {
                                laboralCity = addressOffice.city;
                                (self = {
                                    address: {
                                        address: addressOffice.address ? addressOffice.address : '',
                                        city: {
                                            province_code: laboralCity.province_code
                                                ? (laboralCity.province_code || '') + ''
                                                : '',
                                            city_code: laboralCity.province_code ? laboralCity.city_code : '',
                                        },
                                    },
                                }),
                                    (res = this.buildAddressesBody(self, 'LABORAL'));
                                if (occupationSelected.id !== 3 &&
                                    occupationSelected.id !== 4 &&
                                    occupationSelected.id !== 5) {
                                    body.data.addresses.push(res);
                                }
                            }
                        }
                        else {
                            switch (type) {
                                case 'PARTICULAR':
                                    self = this.abreCuentasService.getContactInfo();
                                    res = this.buildAddressesBody(self, type);
                                    body.data.addresses.push(res);
                                    break;
                                case 'LABORAL':
                                    if (this.abreCuentasService.getAbreCuentasModel().occupationSelected
                                        .id === 5) {
                                        break;
                                    }
                                    self = this.abreCuentasService.getOfficeInfo(this.abreCuentasService.getOccupationSelected().id + '');
                                    res = this.buildAddressesBody(self, type);
                                    body.data.addresses.push(res);
                                    break;
                                case 'CARD_SEND':
                                    self = this.abreCuentasService.getAddressInfoConfigTc();
                                    // const normalizedAddress = this.stringHelperService.normalizeAddress(
                                    //   self.address,
                                    //   self.detail || '',
                                    // );
                                    (self = {
                                        address: {
                                            address: self.address,
                                            city: {
                                                province_code: self.city.province_code,
                                                city_code: self.city.city_code,
                                            },
                                        },
                                    }),
                                        (type = 'ENTREGA_MEDIO');
                                    res = this.buildAddressesBody(self, type);
                                    body.data.addresses.push(res);
                                    break;
                                default:
                                    occupation = this.abreCuentasService.getOccupationSelected();
                                    ciiu = this.abreCuentasService.getCiiuSelected();
                                    // tslint:disable-next-line:early-exit
                                    if (occupation.id === 2 && ciiu.ciiu === '090') {
                                        self = this.abreCuentasService.getContactInfo();
                                        res = this.buildAddressesBody(self, 'PARTICULAR');
                                        body.data.addresses.push(res);
                                    }
                                    break;
                            }
                        }
                        if (!this.validationHelperService.isPassiveProduct()) {
                            body.data = {
                                clients: [
                                    tslib_1.__assign({ document: {
                                            type: this.abreCuentasService.getDocumentInfo().document_type,
                                            number: this.abreCuentasService.getDocumentInfo().document_number,
                                        } }, body.data),
                                ],
                            };
                            if (this.abreCuentasService.getproductSelected().product_type ===
                                BUSINESS_CONST.PRODUCT_TYPE_LIVING &&
                                typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                                typeof this.abreCuentasService.getSecondHeadline().has_second_headline) {
                                bodySecondHeadline = {};
                                dataSecondHeadline = this.abreCuentasService.getContactInfoSecondHeadline();
                                bodySecondHeadline = this.buildAddressesBody(dataSecondHeadline, type || '');
                                secondData = {
                                    document: {
                                        type: this.abreCuentasService.getBasicInfoSecondHeadline()
                                            .doc_type_second_headline,
                                        number: this.abreCuentasService.getBasicInfoSecondHeadline()
                                            .doc_number_second_headline,
                                    },
                                    addresses: [bodySecondHeadline],
                                };
                                body.data.clients.push(secondData);
                            }
                        }
                        return [4 /*yield*/, this.requestService
                                .createCaseAddress(body, this.abreCuentasService.getSolicitationId())
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    _this.code = '500';
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    CaptureService.prototype.buildBodyContactLaboral = function (data) {
        return {
            data: {
                emails: [
                    {
                        email_type: 'PARTICULAR',
                        email: data.email,
                    },
                ],
                phones: [
                    {
                        phone_type: 'LABORAL',
                        phone_number: data.employment_number,
                    },
                ],
                solicitation_id: this.abreCuentasService.getSolicitationId(),
            },
        };
    };
    CaptureService.prototype.buildBodyContactParticular = function (data) {
        return {
            data: {
                emails: [
                    {
                        email_type: 'PARTICULAR',
                        email: data.email,
                    },
                ],
                phones: [
                    {
                        phone_type: 'CELULAR',
                        phone_number: data.mobile_number,
                    },
                    {
                        phone_type: 'PARTICULAR',
                        phone_number: data.mobile_number,
                    },
                ],
                solicitation_id: this.abreCuentasService.getSolicitationId(),
            },
        };
    };
    CaptureService.prototype.createContactInfo = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, _a, isPostlogin, ContactModel, contactSecondHeadlineModel, data, bodySecondHeadline, dataSecondHeadline, secondData, solicitationId;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        body = {};
                        _a = this.abreCuentasService.getAbreCuentasModel(), isPostlogin = _a.isPostlogin, ContactModel = _a.ContactModel, contactSecondHeadlineModel = _a.contactSecondHeadlineModel;
                        type = isPostlogin ? 'PARTICULAR' : type;
                        data = ContactModel;
                        switch (type) {
                            case 'LABORAL':
                                body = this.buildBodyContactLaboral(data);
                                break;
                            case 'PARTICULAR':
                                body = this.buildBodyContactParticular(data);
                                break;
                        }
                        if (isPostlogin &&
                            data.employment_number &&
                            data.employment_number !== '') {
                            body.data.phones.push({
                                phone_type: 'LABORAL',
                                phone_number: data.employment_number,
                            });
                        }
                        if (!this.validationHelperService.isPassiveProduct()) {
                            body.data = {
                                clients: [
                                    tslib_1.__assign({ document: {
                                            type: this.abreCuentasService.getDocumentInfo().document_type,
                                            number: this.abreCuentasService.getDocumentInfo().document_number,
                                        } }, body.data),
                                ],
                            };
                            if (this.abreCuentasService.getproductSelected().product_type ===
                                BUSINESS_CONST.PRODUCT_TYPE_LIVING &&
                                typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                                typeof this.abreCuentasService.getSecondHeadline()
                                    .has_incomes_second_headline !== 'undefined') {
                                bodySecondHeadline = {};
                                dataSecondHeadline = contactSecondHeadlineModel;
                                bodySecondHeadline =
                                    this.buildBodyContactParticular(dataSecondHeadline);
                                secondData = tslib_1.__assign({ document: {
                                        type: this.abreCuentasService.getBasicInfoSecondHeadline()
                                            .doc_type_second_headline,
                                        number: this.abreCuentasService.getBasicInfoSecondHeadline()
                                            .doc_number_second_headline,
                                    } }, bodySecondHeadline.data);
                                body.data.clients.push(secondData);
                            }
                        }
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .createCaseContactInfo(body, solicitationId)
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    throw 500;
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    CaptureService.prototype.buildFinancialBody = function (data) {
        var otherFunds = data.otherFinancialModel.otherFunds
            ? data.otherFinancialModel.otherFunds
            : null;
        var otherIncomes = data.otherFinancialModel.otherIncomes
            ? +data.otherFinancialModel.otherIncomes
            : 0;
        var product_type = data.productSelected.product_type;
        var body = {
            document: {
                type: data.document_type,
                number: data.document_number,
            },
            segment: null,
            segment_additional_info: {
                segment_id: data.isPostlogin
                    ? data.customerData.basic.sub_segment_id
                    : data.infoInferredIncomes.segment_id,
                // data.infoInferredIncomes.segment_id, To do
                sub_segment_id: data.isPostlogin
                    ? data.customerData.basic.segment_id
                    : 'AAQ',
            },
            incomes_info: {
                principal_activity: '010',
                principal_income: {
                    currency: 'COP',
                    amount: data.financialModel.incomes,
                    decimals: 0,
                },
                alternative_incomes_description: otherFunds,
                alternative_incomes: {
                    currency: 'COP',
                    amount: otherIncomes,
                    decimals: 0,
                },
                source_other_incomes: data.financialModel.funds,
            },
            discounts_info: {
                additionals_discounts: {
                    currency: 'COP',
                    amount: data.financialModel.expensesDiscount,
                    decimals: 0,
                },
            },
            monthly_outcome: {
                currency: 'COP',
                amount: data.financialModel.expenses,
                decimals: 0,
            },
            active_amount: {
                currency: 'COP',
                amount: data.financialModel.goods,
                decimals: 0,
            },
            passive_amount: {
                currency: 'COP',
                amount: data.financialModel.debt,
                decimals: 0,
            },
            agreement_code: data.agreementSelected.agreement_code,
        };
        if (this.validationHelperService.isPassiveProduct()) {
            body.incomes_info['type_incomes'] = data.infoInferredIncomes.income_type;
            body.incomes_info['alternative_source_incomes'] =
                data.infoInferredIncomes.income_amount;
            body.incomes_info['source_incomes'] =
                data.infoInferredIncomes.source_type;
        }
        if (data.occupationSelected.id === 1) {
            var hiringDate = void 0;
            var laborCompany = void 0;
            var branchCode = void 0;
            var companyName = data.officeModel[data.officeModel.length - 1].company_name;
            var newCompanyDate = data.employedContractModel.contractDate;
            laborCompany = companyName
                ? companyName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                : this.dataClient.financial.labor_company;
            if ((product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
                product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) &&
                !data.isPostlogin) {
                hiringDate = newCompanyDate;
            }
            else {
                hiringDate = newCompanyDate
                    ? newCompanyDate
                    : data.customerData.financial.company_start_date.trim();
            }
            branchCode =
                (data.employedContractModel.typeContract.elementId || '') + '';
            body['branch_code'] = branchCode;
            body['labor_company'] = laborCompany;
            body['hiring_date'] =
                hiringDate !== '' ? hiringDate.split('/').reverse().join('-') : null;
        }
        if (data.occupationSelected.id === 2) {
            body = tslib_1.__assign({}, body, { incomes_info: tslib_1.__assign({}, body.incomes_info, { principal_activity: data.ciiuModel.ciiu
                        ? data.ciiuModel.ciiu
                        : data.customerData.basic.professional_activity.find(function (item) { return item.key === 'sic'; }).name }) });
            body['hiring_date'] = data.ciiuDate.split('/').reverse().join('-');
            body['labor_company'] =
                data.officeModel[data.occupationSelected.id] &&
                    data.officeModel[data.occupationSelected.id].company_name
                    ? data.officeModel[data.occupationSelected.id].company_name
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                    : '';
        }
        return body;
    };
    CaptureService.prototype.createFinancials = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, infoInferredIncomes, isPostlogin, financialModel, otherFinancialModel, productSelected, occupationSelected, agreementSelected, officeModel, employedContractModel, ciiuModel, ciiuDate, customerData, documentModel, self, data, body, _b, basicInfoSecondHeadlineModel, occupationSelectedSecondHeadline, employedContractSecondHeadlineModel, financialSecondHeadlineModel, otherFinancialSecondHeadlineModel, ciiuSecondModel, ciiuSecondDate, officeSecondHeadlineModel, data2, body2;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.abreCuentasService.getAbreCuentasModel(), infoInferredIncomes = _a.infoInferredIncomes, isPostlogin = _a.isPostlogin, financialModel = _a.financialModel, otherFinancialModel = _a.otherFinancialModel, productSelected = _a.productSelected, occupationSelected = _a.occupationSelected, agreementSelected = _a.agreementSelected, officeModel = _a.officeModel, employedContractModel = _a.employedContractModel, ciiuModel = _a.ciiuModel, ciiuDate = _a.ciiuDate, customerData = _a.customerData, documentModel = _a.documentModel;
                        self = this.abreCuentasService.getAbreCuentasModel();
                        this.dataClient = this.abreCuentasService.getCustomerData();
                        this.financialInfo = this.abreCuentasService.getFinancialInfo();
                        data = tslib_1.__assign({ infoInferredIncomes: infoInferredIncomes,
                            isPostlogin: isPostlogin,
                            financialModel: financialModel,
                            otherFinancialModel: otherFinancialModel,
                            productSelected: productSelected,
                            occupationSelected: occupationSelected,
                            agreementSelected: agreementSelected,
                            officeModel: officeModel,
                            employedContractModel: employedContractModel,
                            ciiuModel: ciiuModel,
                            ciiuDate: ciiuDate,
                            customerData: customerData }, documentModel);
                        body = this.buildFinancialBody(data);
                        if (occupationSelected.id) {
                            body.profession = occupationSelected.id;
                        }
                        if (!this.validationHelperService.isPassiveProduct()) {
                            body = [
                                tslib_1.__assign({ document: {
                                        type: this.abreCuentasService.getDocumentInfo().document_type,
                                        number: this.abreCuentasService.getDocumentInfo().document_number,
                                    } }, body),
                            ];
                        }
                        if (typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                            this.abreCuentasService.getSecondHeadline().has_second_headline &&
                            productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                            _b = this.abreCuentasService.getAbreCuentasModel(), basicInfoSecondHeadlineModel = _b.basicInfoSecondHeadlineModel, occupationSelectedSecondHeadline = _b.occupationSelectedSecondHeadline, employedContractSecondHeadlineModel = _b.employedContractSecondHeadlineModel, financialSecondHeadlineModel = _b.financialSecondHeadlineModel, otherFinancialSecondHeadlineModel = _b.otherFinancialSecondHeadlineModel, ciiuSecondModel = _b.ciiuSecondModel, ciiuSecondDate = _b.ciiuSecondDate, officeSecondHeadlineModel = _b.officeSecondHeadlineModel;
                            data2 = {
                                infoInferredIncomes: infoInferredIncomes,
                                isPostlogin: isPostlogin,
                                agreementSelected: agreementSelected,
                                occupationSelected: occupationSelectedSecondHeadline,
                                financialModel: financialSecondHeadlineModel,
                                otherFinancialModel: otherFinancialSecondHeadlineModel,
                                officeModel: officeSecondHeadlineModel,
                                employedContractModel: employedContractSecondHeadlineModel,
                                productSelected: productSelected,
                                ciiuModel: ciiuSecondModel,
                                ciiuDate: ciiuSecondDate,
                                customerData: customerData,
                            };
                            body2 = this.buildFinancialBody(data2);
                            if (occupationSelectedSecondHeadline.id) {
                                body2.profession = occupationSelectedSecondHeadline.id;
                            }
                            (body2.document = {
                                type: 1,
                                number: basicInfoSecondHeadlineModel.doc_number_second_headline,
                            }),
                                body.push(body2);
                        }
                        return [4 /*yield*/, this.requestService
                                .createCaseFinancials({ data: body }, this.abreCuentasService.getSolicitationId())
                                .then(function () {
                                try {
                                    _this.code = '200';
                                }
                                catch (error) {
                                    throw 500;
                                }
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /**
     * Función para evaluar un boolean y retornar un valor
     * Se usa para disminuir el branching
     * @param value Valor a evaluar
     * @param caseTrue Retorno en caso true
     * @param caseFalse Retorno en caso false
     */
    CaptureService.prototype.getValueByValidateBoolean = function (value, caseTrue, caseFalse) {
        return value ? caseTrue : caseFalse;
    };
    CaptureService.prototype.buildPerformeIncomeBody = function (data, account_holder_type) {
        var incomes_sum_flag = typeof data.secondHeadlineModel === 'undefined'
            ? false
            : data.secondHeadlineModel.has_incomes_second_headline;
        data.document_type =
            data.product_type == BUSINESS_CONST.PRODUCT_TYPE_LIVING
                ? data.document_type
                : this.validationHelperService.filterDocumentType(data.document_type);
        var segment_additional_info;
        if (data.isPostlogin) {
            segment_additional_info = {
                segment_additional_info: {
                    segment_id: data.basicModel.sub_segment_id,
                    sub_segment_id: data.basicModel.segment_id,
                },
            };
        }
        console.warn('data recibida: ', data);
        var dataBirthDate = data.birthdate ? data.birthdate : data.date_of_issue;
        var formatBirthdate = this.formatBirthDate(dataBirthDate);
        return tslib_1.__assign({ document: {
                type: data.document_type,
                number: data.document_number,
            }, incomes_sum_flag: incomes_sum_flag, first_name: data.firstname, first_surname: data.primary_lastname, second_name: data.middlename, second_surname: data.second_lastname, birthdate: formatBirthdate + 'T', account_holder_type: account_holder_type }, segment_additional_info);
    };
    /**
     * Función para realizar el llamado de terceras fuentes desde bizagi
     *
     * *Function to call incomes since bizagi*
     *
     * @type {function}
     * @returns {this.code}
     */
    CaptureService.prototype.performIncomes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isUserJemelii, _a, documentModel, isPostlogin, basicModel, productSelected, account_holder_type, data, firmlyApproved, body, _b, basicInfoSecondHeadlineModel, secondHeadlineModel, mapNames, mapbody, dataSecondHeadLine;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        isUserJemelii = this.abreCuentasService.getUserJemelii();
                        _a = this.abreCuentasService.getAbreCuentasModel(), documentModel = _a.documentModel, isPostlogin = _a.isPostlogin, basicModel = _a.basicModel, productSelected = _a.productSelected;
                        account_holder_type = '01';
                        data = this.buildPerformeIncomeBody(tslib_1.__assign({}, documentModel, { isPostlogin: isPostlogin, basicModel: basicModel }, productSelected), account_holder_type);
                        data.is_client = isUserJemelii ? false : isPostlogin;
                        console.log('///** PERFORME INCONMES IS_CLIENT ' + data.is_client);
                        firmlyApproved = !this.firmlyApprovedService.isEmpty() &&
                            this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
                            ? true
                            : false;
                        body = {
                            solicitation_type: 'tskConsultarWaiver',
                            offer_approved_ind: firmlyApproved,
                            clients: [
                                tslib_1.__assign({}, data),
                            ],
                        };
                        if (typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                            this.abreCuentasService.getSecondHeadline().has_incomes_second_headline &&
                            this.abreCuentasService.getSecondHeadline().has_second_headline) {
                            _b = this.abreCuentasService.getAbreCuentasModel(), basicInfoSecondHeadlineModel = _b.basicInfoSecondHeadlineModel, secondHeadlineModel = _b.secondHeadlineModel;
                            mapNames = this.validationHelperService.splitNames(basicInfoSecondHeadlineModel.name_second_headline, basicInfoSecondHeadlineModel.lastname_second_headline);
                            mapbody = {
                                document_type: basicInfoSecondHeadlineModel.doc_type_second_headline,
                                document_number: basicInfoSecondHeadlineModel.doc_number_second_headline,
                                firstname: mapNames.firstname,
                                primary_lastname: mapNames.primary_lastname,
                                middlename: mapNames.middlename,
                                second_lastname: mapNames.second_lastname,
                                birthdate: basicInfoSecondHeadlineModel.birthdate_second_headline,
                                secondHeadlineModel: secondHeadlineModel,
                            };
                            account_holder_type = '02';
                            dataSecondHeadLine = this.buildPerformeIncomeBody(mapbody, account_holder_type);
                            body.clients.push(dataSecondHeadLine);
                        }
                        if (this.channel.getChannelId() === '163') {
                            // body.offer_approved_inf = true,
                            body.partner = {
                                document: {
                                    number: this.abreCuentasService.getRateAlly().partner.document.number,
                                },
                            };
                        }
                        return [4 /*yield*/, this.requestService
                                .performIncomes({ data: body }, this.abreCuentasService.getSolicitationId())
                                .then(function (result) {
                                _this.code = result.status.toString();
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /**
     * Función que obtiene el resultado de pco
     *
     * *Function get pco result*
     *
     */
    CaptureService.prototype.getResultPco = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productSelected, productType, data, date, laborDate, employment_type, codCity, is_pep_client, sicCode, civil_status, stratum, homeType, genderPerson, dateOcupation, actualDate, resultDate, taxInfo, body, solicitation, val;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                productSelected = this.abreCuentasService.getproductSelected();
                productType = productSelected ? productSelected.product_type : '';
                data = this.abreCuentasService.getAbreCuentasModel();
                laborDate = {};
                codCity = '';
                is_pep_client = '';
                sicCode = '';
                civil_status = 0;
                stratum = '';
                homeType = '';
                genderPerson = '';
                switch (data.occupationSelected.id) {
                    case 1:
                        date = data.employedContractModel.contractDate || '';
                        employment_type =
                            data.employedContractModel.typeContract.elementId + '';
                        break;
                    case 2:
                        date = data.ciiuDate || '';
                        employment_type = '';
                        break;
                    default:
                        break;
                }
                if (date) {
                    dateOcupation = date.split('/');
                    actualDate = new Date();
                    resultDate = +actualDate.getMonth() +
                        actualDate.getFullYear() * 12 -
                        (+dateOcupation[1] + +dateOcupation[2] * 12);
                    laborDate = {
                        labor_seniority: [
                            {
                                count: Math.floor(resultDate / 12) + '',
                                unit_type: 'Years',
                            },
                            {
                                count: (resultDate % 12) + '',
                                unit_type: 'Months',
                            },
                        ],
                    };
                }
                if (productType === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                    productType === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                    productType === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                    codCity =
                        data.ContactModel.address.city.province_code +
                            '-' +
                            data.ContactModel.address.city.city_code;
                    is_pep_client = data.fiModel['IsPEP'].value === 'no' ? '0' : '1';
                    sicCode = data.occupationSelected.ciiu;
                    civil_status =
                        data.maritalStatusModel.marital_status_code !== undefined
                            ? data.maritalStatusModel.marital_status_code
                            : 0;
                    stratum =
                        data.ContactModel.address.stratum !== undefined
                            ? data.ContactModel.address.stratum
                            : '';
                    homeType =
                        data.ContactModel.address.housingType !== undefined
                            ? data.ContactModel.address.housingType.housingId
                            : '';
                    genderPerson = this.abreCuentasService.getPostlogin()
                        ? this.abreCuentasService.getBasicInfo().gender
                        : data.documentModel.sex;
                }
                taxInfo = this.abreCuentasService.getinfoInferredIncomes().segmentation_id === 335
                    ? 'sucursal'
                    : 'PB';
                body = tslib_1.__assign({ document: {
                        number: data.documentModel.document_number,
                        type: 'CC',
                    }, first_name: data.documentModel.firstname, second_name: data.documentModel.middlename
                        ? data.documentModel.middlename
                        : '', first_surname: data.documentModel.primary_lastname, second_surname: data.documentModel.second_lastname, birthdate: data.documentModel.birthdate.replace(/\//g, '-'), phone: data.ContactModel.mobile_number, employment_type: employment_type, principal_activity_id: data.occupationSelected.id + '', is_client_flag: !this.abreCuentasService.getProspectResponse().client, income_source: data.infoInferredIncomes.source_type, income_amount: [
                        {
                            amount: {
                                currency: 'COP',
                                amount: data.infoInferredIncomes.income_amount.amount,
                                decimals: 0,
                            },
                            type: data.infoInferredIncomes.income_type,
                        },
                        {
                            amount: {
                                currency: 'COP',
                                amount: data.financialModel.incomes,
                                decimals: 0,
                            },
                            type: 'Fixed',
                        },
                        {
                            amount: {
                                currency: 'COP',
                                amount: data.otherFinancialModel.otherIncomes !== undefined
                                    ? data.otherFinancialModel.otherIncomes
                                    : 0,
                                decimals: 0,
                            },
                            type: 'Other',
                        },
                    ] }, laborDate, { solicitation_product: [
                        {
                            product_type: productSelected.product_code,
                            priority: '1',
                            limit_amount: {
                                currency: 'COP',
                                decimals: 2,
                            },
                            period: '90',
                            hood_type: 0,
                        },
                    ], pep_cliente: is_pep_client, sic_code: sicCode, marital_status: civil_status.toString(), social_class: stratum.toString(), home_type: homeType.toString(), gender: genderPerson, city: codCity });
                solicitation = body.solicitation_product[0];
                if (productType === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                    solicitation.limit_amount['amount'] = data.creditParms.maxAmountValue;
                    val = this.helperService.getRateBySegment(data.creditParms.rateValue, data.infoInferredIncomes.segment_id, 'NMV', RISK_LEVELS.NORISK);
                    (solicitation['rate'] = parseFloat(val.replace(',', '.').replace('%', ''))),
                        (solicitation['term'] = data.creditParms.maxPeriodValue);
                }
                else {
                    solicitation.limit_amount['amount'] = 500000000;
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .getResultPco({ data: body })
                            .then(function (res) {
                            if (res.status === 200) {
                                _this.abreCuentasService.setPcoModel(res.body.data);
                                return resolve(res.body.data);
                            }
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    CaptureService.prototype.buildPerformPcoBody = function (data, role) {
        var _this = this;
        var typeProductsSelected;
        if (data.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            typeProductsSelected = [
                {
                    product_type: data.product_type,
                    prioritizeForClient: '1',
                    product_code: data.product_code,
                },
            ];
        }
        else if (data.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
            typeProductsSelected = [
                {
                    product_type: data.product_type,
                    prioritizeForClient: '1',
                    product_code: data.product_code,
                },
            ];
        }
        else {
            typeProductsSelected = this.abreCuentasService
                .getProductsSelects()
                .map(function (dataResponse) {
                return {
                    product_type: dataResponse.product_type,
                    product_code: dataResponse.product_code,
                    prioritizeForClient: dataResponse.prioritizeForClient,
                };
            });
        }
        var date;
        var contract_type = null;
        var years;
        var months;
        var duration_list = {};
        var prospect = this.abreCuentasService.getProspectResponse();
        var incomes_sum_flag = typeof data.secondHeadlineModel === 'undefined'
            ? false
            : data.secondHeadlineModel.has_incomes_second_headline;
        var products = [];
        typeProductsSelected.forEach(function (dataObjProduct) {
            if (dataObjProduct.product_type === BUSINESS_CONST.MULTI) {
                return;
            }
            var dataProduct = {};
            if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                dataProduct = {
                    product_type: dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING
                        ? _this.abreCuentasService.getOtherSimulationData().sub_product
                        : dataObjProduct.product_code,
                    product_subtype: _this.abreCuentasService.getOtherSimulationData().code,
                };
            }
            else if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                dataProduct = {
                    product_type: dataObjProduct.product_code,
                };
            }
            else if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                dataProduct = {
                    product_type: dataObjProduct.product_code,
                    product_subtype: '533',
                };
            }
            else if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                dataProduct = {
                    product_type: dataObjProduct.product_code,
                    product_subtype: '371',
                    product_destination_type: _this.abreCuentasService.getProductDestinationType(),
                };
            }
            else {
                dataProduct = {
                    product_type: dataObjProduct.product_code,
                    product_subtype: prospect.client === false
                        ? '131'
                        : _this.helperService.getProductCodeBySegmentId(data.sub_segment_id),
                };
            }
            var allInfoProduct = {
                product: dataProduct,
                priority: dataObjProduct.prioritizeForClient,
            };
            if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
                dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                var aditionalData = {
                    installments_quantity: _this.abreCuentasService.getAbreCuentasModel().creditParms
                        .maxPeriodValue,
                    term: {
                        frecuency: 'MM',
                    },
                    available_amount: {
                        amount: _this.abreCuentasService.getAbreCuentasModel().creditParms
                            .maxAmountValue,
                        decimals: 0,
                        currency: 'COP',
                    },
                };
                allInfoProduct = Object.assign(allInfoProduct, aditionalData);
            }
            if (dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                var simulatorModel = _this.abreCuentasService.getAbreCuentasModel().simulatorModel;
                if (simulatorModel.product_subline === '03' ||
                    simulatorModel.product_subline === '55') {
                    var liabilities = [
                        {
                            liability_id: simulatorModel.libialities.liability_id,
                            bank_id: simulatorModel.libialities.liability_id,
                            bank_name: simulatorModel.libialities.bank_name,
                            payoff_amount: {
                                currency: simulatorModel.available_amount.currency,
                                amount: simulatorModel.available_amount.amount,
                                decimals: simulatorModel.available_amount.decimals,
                            },
                        },
                    ];
                    var objectLiving = { liabilities: liabilities, fee_amount: simulatorModel.fee };
                    allInfoProduct = Object.assign(allInfoProduct, objectLiving);
                }
                var data_living = {
                    assisted_housing_flag: simulatorModel.assisted_housing_flag,
                    new_housing_flag: simulatorModel.new_housing_flag,
                    financing_type: simulatorModel.financing_type,
                    purchase_option: simulatorModel.purchase_option,
                    own_project_flag: simulatorModel.own_project_flag,
                    capital_amount: simulatorModel.property_amount,
                };
                allInfoProduct = Object.assign(allInfoProduct, data_living);
            }
            if (_this.abreCuentasService.getFlowLoan() && dataObjProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                var destinity = {
                    destinity: _this.abreCuentasService.getRequestLoanSelected().elementId,
                };
                allInfoProduct = Object.assign(allInfoProduct, destinity);
                var getCreditSelection = _this.abreCuentasService.getCreditList();
                if (getCreditSelection) {
                    getCreditSelection.map(function (value) {
                        _this.credit_recharge_up_information.push({
                            credit_recharge_up_id: value.number,
                            account_subtype: value.type,
                            payoff_amount: {
                                currency: BANK_INFO_CONST.CURRENCY,
                                amount: value.amount,
                                decimals: 0,
                            },
                            monthly_fee_amount: {
                                currency: BANK_INFO_CONST.CURRENCY,
                                amount: '',
                                decimals: 0,
                            },
                        });
                    });
                    var recharge = { credit_recharge_up_information: _this.credit_recharge_up_information };
                    allInfoProduct = Object.assign(allInfoProduct, recharge);
                }
                var fee_amount = {
                    fee_amount: {
                        currency: 'COP',
                        amount: _this.abreCuentasService.getSaveValueInputAmount()
                            ? _this.abreCuentasService.getSaveValueInputAmount()
                            : '0',
                        decimals: 0,
                    },
                };
                allInfoProduct = Object.assign(allInfoProduct, fee_amount);
            }
            products.push(allInfoProduct);
        });
        if (data.typeContract.elementId) {
            switch (data.id) {
                case 1:
                    date = data.contractDate || '';
                    contract_type = data.typeContract.elementId + '';
                    break;
                case 2:
                    date = data.ciiuDate || '';
                    contract_type = '';
                    break;
                default:
                    break;
            }
        }
        if (date) {
            var dateOcupation = date.split('/');
            var actualDate = new Date();
            var resultDate = +actualDate.getMonth() +
                actualDate.getFullYear() * 12 -
                (+dateOcupation[1] + +dateOcupation[2] * 12);
            if (+actualDate.getMonth() + 1 === +dateOcupation[1] &&
                +actualDate.getDate() >= +dateOcupation[0]) {
                resultDate += 1;
            }
            years = Math.floor(resultDate / 12) + '';
            months = (resultDate % 12) + '';
            duration_list = {
                duration: [
                    {
                        count: years,
                        unit: 'Years',
                    },
                    {
                        count: months,
                        unit: 'Months',
                    },
                ],
            };
        }
        var clients = {
            document: {
                number: data.document_number,
                type: data.document_type,
            },
            gender: data.isPostlogin ? data.gender : data.sex,
            social_class: data.address.stratum.toString(),
            housing_type: data.address.housingType.housingId.toString(),
            marital_status: data.marital_status_code.toString(),
            role: role,
            // profession: data.id.toString(),
            profession: data.id ? data.id.toString() : '2',
            incomes_info: {
                principal_activity: data.ciiu,
                contract_type: contract_type,
                incomes_sum_flag: incomes_sum_flag,
                principal_income: {
                    currency: 'COP',
                    amount: data.incomes,
                    decimals: 0,
                },
                alternative_incomes: {
                    currency: 'COP',
                    amount: data.otherIncomes !== undefined ? data.otherIncomes : 0,
                    decimals: 0,
                },
            },
            duration_list: tslib_1.__assign({}, duration_list),
            pep_questions: [
                {
                    question_id: '1',
                    answer: data.IsPEP !== undefined ? data.IsPEP.elementId === 1 : false,
                    justification: 'NA',
                },
            ],
        };
        return { clients: clients, products: products };
    };
    /**
     * Función para llamar los servicios de pco desde bizagi
     *
     * *Function to call pco since bizagi*
     *
     * @type {function}
     * @returns {this.code}
     */
    CaptureService.prototype.performPco = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, documentModel, financialModel, otherFinancialModel, employedContractModel, 
            // tslint:disable-next-line: no-shadowed-variable
            ContactModel, productSelected, occupationSelected, secondHeadlineModel, otherSimulationData, ciiuModel, fiModel, basicModel, maritalStatusModel, creditParms, infoInferredIncomes, ciiuDate, isPostlogin, models, role, _b, clients, products, refund_information, body, _c, contactSecondHeadlineModel, basicInfoSecondHeadlineModel, occupationSelectedSecondHeadline, employedContractSecondHeadlineModel, financialSecondHeadlineModel, otherFinancialSecondHeadlineModel, fiSecondHeadlineModel, maritalStatusSecondHeadlineModel, ciiuSecondModel, ciiuSecondDate, mapNames, mapbody, data;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.abreCuentasService.getAbreCuentasModel(), documentModel = _a.documentModel, financialModel = _a.financialModel, otherFinancialModel = _a.otherFinancialModel, employedContractModel = _a.employedContractModel, ContactModel = _a.ContactModel, productSelected = _a.productSelected, occupationSelected = _a.occupationSelected, secondHeadlineModel = _a.secondHeadlineModel, otherSimulationData = _a.otherSimulationData, ciiuModel = _a.ciiuModel, fiModel = _a.fiModel, basicModel = _a.basicModel, maritalStatusModel = _a.maritalStatusModel, creditParms = _a.creditParms, infoInferredIncomes = _a.infoInferredIncomes, ciiuDate = _a.ciiuDate, isPostlogin = _a.isPostlogin;
                        models = tslib_1.__assign({}, documentModel, financialModel, otherFinancialModel, employedContractModel, productSelected, occupationSelected, { otherSimulationData: otherSimulationData }, maritalStatusModel, basicModel, fiModel, ContactModel, { creditParms: creditParms }, infoInferredIncomes, { ciiuModel: ciiuModel,
                            ciiuDate: ciiuDate,
                            secondHeadlineModel: secondHeadlineModel,
                            isPostlogin: isPostlogin });
                        role = '1';
                        return [4 /*yield*/, this.buildPerformPcoBody(models, role)];
                    case 1:
                        _b = _d.sent(), clients = _b.clients, products = _b.products;
                        refund_information = this.abreCuentasService.getDisbursementInfo();
                        body = {
                            solicitation_type: 'tskConsPCOViabilidad',
                            channel_code: '01',
                            clients: [
                                tslib_1.__assign({}, clients),
                            ],
                            products: products,
                            refund_information: refund_information,
                            agreement: {
                                agreement_code: this.abreCuentasService.getAgreementSelected().agreement_number,
                                agreement_group: '',
                                agreement_rate_type: '',
                                agreement_sector: '',
                                agreement_status: '',
                            },
                        };
                        if (typeof this.abreCuentasService.getSecondHeadline() !== 'undefined' &&
                            this.abreCuentasService.getSecondHeadline().has_second_headline &&
                            this.abreCuentasService.getSecondHeadline().has_incomes_second_headline) {
                            _c = this.abreCuentasService.getAbreCuentasModel(), contactSecondHeadlineModel = _c.contactSecondHeadlineModel, basicInfoSecondHeadlineModel = _c.basicInfoSecondHeadlineModel, occupationSelectedSecondHeadline = _c.occupationSelectedSecondHeadline, employedContractSecondHeadlineModel = _c.employedContractSecondHeadlineModel, financialSecondHeadlineModel = _c.financialSecondHeadlineModel, otherFinancialSecondHeadlineModel = _c.otherFinancialSecondHeadlineModel, fiSecondHeadlineModel = _c.fiSecondHeadlineModel, maritalStatusSecondHeadlineModel = _c.maritalStatusSecondHeadlineModel, ciiuSecondModel = _c.ciiuSecondModel, ciiuSecondDate = _c.ciiuSecondDate;
                            mapNames = this.validationHelperService.splitNames(basicInfoSecondHeadlineModel.name_second_headline, basicInfoSecondHeadlineModel.lastname_second_headline);
                            mapbody = tslib_1.__assign({ document_type: this.validationHelperService.filterDocumentType(String(basicInfoSecondHeadlineModel.doc_type_second_headline)), document_number: basicInfoSecondHeadlineModel.doc_number_second_headline, firstname: mapNames.firstname, primary_lastname: mapNames.primary_lastname, middlename: mapNames.middlename, second_lastname: mapNames.second_lastname }, occupationSelectedSecondHeadline, employedContractSecondHeadlineModel, financialSecondHeadlineModel, otherFinancialSecondHeadlineModel, fiSecondHeadlineModel, { ciiuSecondModel: ciiuSecondModel }, contactSecondHeadlineModel, { birthdate: basicInfoSecondHeadlineModel.birthdate_second_headline }, productSelected, { secondHeadlineModel: secondHeadlineModel,
                                otherSimulationData: otherSimulationData }, maritalStatusSecondHeadlineModel, { creditParms: creditParms, gender: basicInfoSecondHeadlineModel.gender_second_headline, sex: basicInfoSecondHeadlineModel.gender_second_headline, ciiu: ciiuSecondModel.ciiu, ciiuDate: ciiuSecondDate });
                            role = '17';
                            data = this.buildPerformPcoBody(mapbody, role);
                            body.clients.push(data.clients);
                        }
                        if (this.channel.getChannelId() === CHANNEL.PORTALALLIES.CODE) {
                            body.products[0].rates = this.abreCuentasService.getRateAlly().rates;
                            body.channel_code = '04';
                        }
                        console.warn('Consumiendo PerformPCO >>>> Data: ', body);
                        return [4 /*yield*/, this.requestService
                                .performPco({ data: body }, this.abreCuentasService.getSolicitationId())
                                .then(function (result) {
                                _this.code = result.status.toString();
                            })];
                    case 2:
                        _d.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    /**
     * Función para llamar los servicios de pco desde canal
     *
     * *Function to call pco since bizagi*
     *
     * @type {function}
     * @returns {this.code}
     */
    CaptureService.prototype.getChannelComunicator = function (isAlta, phase) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productSelected, poroductsSelectedMulti, solicitationId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productSelected = this.abreCuentasService.getAbreCuentasModel().productSelected;
                        poroductsSelectedMulti = this.abreCuentasService.getProductsSelects();
                        solicitationId = this.abreCuentasService.getSolicitationId();
                        return [4 /*yield*/, this.requestService
                                .getChannelNotification(solicitationId)
                                .then(function (res) {
                                var e_1, _a, e_2, _b;
                                console.log(res);
                                var dataPCO = JSON.parse(_this.cipherService.decrypt(res.data.message)).data[0];
                                var solPhase = {
                                    '01': 'PCO',
                                    '02': 'ZGCRE',
                                    '03': 'VALDOC',
                                    '04': 'ANACRE',
                                    '05': 'GESSEG',
                                    '06': 'FORMAL',
                                    '07': 'ZGCUM',
                                    '08': 'DDA',
                                    '09': 'VALDOCDDA',
                                    '10': 'ALTA',
                                    '11': 'FIN',
                                    '12': 'SARLAFT',
                                    '13': 'TASAS',
                                    '14': 'ALTACLIENTE',
                                    '15': 'ALTAPROD',
                                    '16': 'ESC',
                                    '20': 'FRAUDE',
                                    '17': 'NORMALIZACION',
                                };
                                dataPCO.solicitation_phase = solPhase[dataPCO.solicitation_phase];
                                if (isAlta) {
                                    if (dataPCO.solicitation_phase === 'PCO') {
                                        _this.code = '127';
                                        return;
                                    }
                                    if (dataPCO.solicitation_phase === 'FRAUDE') {
                                        if (['14'].includes(dataPCO.solicitation_status)) {
                                            _this.code = '208';
                                            _this.abreCuentasService.getAbreCuentasModel().pcoModel.solicitation_status.status_code =
                                                '';
                                        }
                                        else if (['04'].includes(dataPCO.solicitation_status)) {
                                            _this.code = '20-14';
                                        }
                                        else {
                                            _this.code = '200';
                                        }
                                        return _this.code;
                                    }
                                    if (dataPCO.solicitation_phase === 'GESSEG') {
                                        if (['05', '05'].includes(dataPCO.solicitation_status)) {
                                            _this.code = '201';
                                            return;
                                        }
                                    }
                                    if (!_this.validationHelperService.isPassiveProduct() &&
                                        _this.firmlyApprovedService.isEmpty()) {
                                        var status_code = _this.abreCuentasService.getPcoModel().solicitation_status
                                            .status_code;
                                        if (status_code === 'PCO01' || status_code === 'PCO03') {
                                            var solHistory = dataPCO.solicitation_status_history.split(',');
                                            var mapHistory = status_code === 'PCO01'
                                                ? ['10', '15', '14', '08', '07', '12']
                                                : ['02', '08', '07', '12'];
                                            var hasValueHistory = false;
                                            try {
                                                for (var mapHistory_1 = tslib_1.__values(mapHistory), mapHistory_1_1 = mapHistory_1.next(); !mapHistory_1_1.done; mapHistory_1_1 = mapHistory_1.next()) {
                                                    var mepEl = mapHistory_1_1.value;
                                                    if (hasValueHistory) {
                                                        break;
                                                    }
                                                    try {
                                                        for (var solHistory_1 = (e_2 = void 0, tslib_1.__values(solHistory)), solHistory_1_1 = solHistory_1.next(); !solHistory_1_1.done; solHistory_1_1 = solHistory_1.next()) {
                                                            var solEl = solHistory_1_1.value;
                                                            if (!solEl.startsWith(mepEl)) {
                                                                continue;
                                                            }
                                                            dataPCO.solicitation_phase = solPhase[mepEl];
                                                            hasValueHistory = true;
                                                            break;
                                                        }
                                                    }
                                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                                    finally {
                                                        try {
                                                            if (solHistory_1_1 && !solHistory_1_1.done && (_b = solHistory_1.return)) _b.call(solHistory_1);
                                                        }
                                                        finally { if (e_2) throw e_2.error; }
                                                    }
                                                }
                                            }
                                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                            finally {
                                                try {
                                                    if (mapHistory_1_1 && !mapHistory_1_1.done && (_a = mapHistory_1.return)) _a.call(mapHistory_1);
                                                }
                                                finally { if (e_1) throw e_1.error; }
                                            }
                                            if (!hasValueHistory) {
                                                _this.code = '127';
                                                return;
                                            }
                                        }
                                    }
                                }
                                var dataGrantedProduct = [];
                                var dataGrantedProductMulti = [];
                                switch (dataPCO.solicitation_phase) {
                                    case 'PCO':
                                        dataPCO.products.map(function (dataProduct) {
                                            if (_this.abreCuentasService.viewOptionMultiProduct) {
                                                var dataSelectedProduc = poroductsSelectedMulti.find(function (data) { return data.product_code === dataProduct.product_type; });
                                                var dataGrantedModel = _this.createObjModelPco(dataSelectedProduc, dataProduct);
                                                dataGrantedProductMulti.push(dataGrantedModel);
                                            }
                                            else {
                                                dataGrantedProduct = _this.createObjModelPco(productSelected, dataProduct);
                                            }
                                        });
                                        var limit_tc = dataPCO.products.find(function (product) { return product.product_type === 'TCR'; });
                                        var resultpc = {
                                            limit_amount: limit_tc ? limit_tc.available_amount.amount : 0,
                                            granted_product: dataGrantedProduct,
                                            granted_product_multi: dataGrantedProductMulti,
                                            solicitation_id: solicitationId,
                                            solicitation_status: {
                                                status_code: dataPCO.solicitation_phase + dataPCO.solicitation_status,
                                                status_description: '',
                                            },
                                        };
                                        dataPCO.prospects.map(function (head) {
                                            if (head.role === '1') {
                                                _this.dataIncome = _this.validationHelperService.setIncomes(head.income);
                                            }
                                        });
                                        _this.abreCuentasService.setinfoInferredIncomes(_this.dataIncome);
                                        _this.abreCuentasService.setPcoModel(resultpc);
                                        var solRates = {
                                            TasaEA: 'E.A.',
                                            TasaNMV: 'M.V.',
                                        };
                                        var dataProductValidation = poroductsSelectedMulti.filter(function (product) {
                                            return product.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE;
                                        });
                                        if (productSelected.product_type ===
                                            BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                                            productSelected.product_type ===
                                                BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
                                            dataProductValidation.length > 0) {
                                            _this.requestService.setRates([
                                                {
                                                    value: dataPCO.credit_analisys[0].name,
                                                    type: solRates[dataPCO.credit_analisys[0].key],
                                                },
                                                {
                                                    value: dataPCO.credit_analisys[1].name,
                                                    type: solRates[dataPCO.credit_analisys[1].key],
                                                },
                                            ]);
                                            var rate = dataPCO.credit_analisys[0].name;
                                            if (rate.split('.')[1] == undefined) {
                                                rate = rate + '.00';
                                            }
                                            _this.abreCuentasService.setRatesOffer({
                                                value: rate.replace(/[.,%]/g, ''),
                                                decimals: rate.split('.')[1].length,
                                            });
                                        }
                                        switch (resultpc.solicitation_status.status_code) {
                                            case 'PCO01':
                                                _this.code = '200';
                                                if (CHANNEL.PORTALO.CODE ===
                                                    _this.channelCommunicatorService.getChannelId() &&
                                                    _this.code === '200') {
                                                    if (_this.abreCuentasService.getflagGreyZone()) {
                                                        // si es verdadero se salto evidente master
                                                        _this.saveBitacora('id_no_PCO_A_cotinuezg');
                                                    }
                                                    else {
                                                        // no se salto evidente
                                                        _this.saveBitacora('id_ok_PCO_A_continueok');
                                                    }
                                                }
                                                else if (CHANNEL.PORTALPN.CODE ===
                                                    _this.channelCommunicatorService.getChannelId()) {
                                                    _this.code = '200';
                                                }
                                                break;
                                            case 'PCO02':
                                                _this.code = '121';
                                                if (CHANNEL.PORTALO.CODE ===
                                                    _this.channelCommunicatorService.getChannelId() &&
                                                    _this.code === '121') {
                                                    if (_this.abreCuentasService.getflagGreyZone()) {
                                                        // si es verdadero se salto evidente master
                                                        _this.saveBitacora('id_no_PCO_R_rechazado');
                                                    }
                                                    else {
                                                        // no se salto evidente
                                                        _this.saveBitacora('id_ok_PCO_R_rechazado');
                                                    }
                                                }
                                                else if (CHANNEL.PORTALPN.CODE ===
                                                    _this.channelCommunicatorService.getChannelId()) {
                                                    _this.code = '121';
                                                }
                                                break;
                                            case 'PCO03':
                                                _this.code = '202';
                                                if (CHANNEL.PORTALO.CODE ===
                                                    _this.channelCommunicatorService.getChannelId() &&
                                                    _this.code === '202') {
                                                    if (_this.abreCuentasService.getflagGreyZone()) {
                                                        // si es verdadero se salto evidente master
                                                        _this.saveBitacora('id_no_PCO_zg_cotinuezg');
                                                    }
                                                    else {
                                                        // no se salto evidente
                                                        _this.saveBitacora('id_ok_PCO_zg_continuezg');
                                                    }
                                                }
                                                else if (CHANNEL.PORTALPN.CODE ===
                                                    _this.channelCommunicatorService.getChannelId()) {
                                                    _this.code = '202';
                                                }
                                                break;
                                            case 'PCO04':
                                                _this.code = '107';
                                                _this.abreCuentasService.setIsErrorPco(true);
                                                break;
                                            default:
                                                _this.code = '107';
                                                break;
                                        }
                                        break;
                                    case 'ALTA':
                                        _this.isCardDuality = _this.abreCuentasService.getCarduality();
                                        var dataArray = dataPCO.products;
                                        if (productSelected.product_type !== BUSINESS_CONST.MULTI &&
                                            !_this.isCardDuality) {
                                            dataArray.map(function (product) {
                                                if (product.product_type === 'AHO' ||
                                                    product.product_type === 'NOM') {
                                                    var productDetail = new DetailAccountModel();
                                                    productDetail.account_number = product.product_id;
                                                    productDetail.create_date_account = dataPCO.last_update_date;
                                                    productDetail.account_type = product.product_type;
                                                    _this.abreCuentasService.setDetailAccountCreation(productDetail);
                                                }
                                                // TODO: VALIDAR PRODUCTOS MULTI
                                                if (product.product_type === 'TCR') {
                                                    var card = {
                                                        solicitation_id: solicitationId,
                                                        solicitation_type: dataPCO.solicitation_type,
                                                        solicitation_status: {
                                                            status_code: '00',
                                                            status_description: 'EXITOSO',
                                                            progress_percentage: 0,
                                                            error_code: '',
                                                            error_description: '',
                                                        },
                                                        product_id: product.product_id,
                                                        product_type: product.product_type,
                                                        client_name: dataPCO.prospects.full_name,
                                                        available_amount: {
                                                            currency: product.available_amount.currency,
                                                            amount: product.available_amount.amount,
                                                            decimals: product.available_amount.decimals,
                                                        },
                                                        expiration_date: product.expiration_date,
                                                    };
                                                    _this.abreCuentasService.setProductCard(card);
                                                }
                                                if (product.product_type === 'ORD' ||
                                                    product.product_type === 'CRP') {
                                                    var detailRevolvingCredit = new DetailRevolvingCreditModel();
                                                    detailRevolvingCredit.available_amount =
                                                        product.available_amount.amount;
                                                    detailRevolvingCredit.product_id = product.product_id;
                                                    _this.abreCuentasService.setDetailRevolvingCreditCreation(detailRevolvingCredit);
                                                }
                                            });
                                            _this.code = '200';
                                        }
                                        else {
                                            if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                                                _this.code = '202';
                                            }
                                            else {
                                                _this.code = '200';
                                            }
                                            var data_alta_pco = _this.abreCuentasService.getPcoModel();
                                            data_alta_pco.granted_product_multi = dataPCO.products;
                                            _this.abreCuentasService.setPcoModel(data_alta_pco);
                                        }
                                        break;
                                    case 'ZGCRE':
                                        _this.code = '201';
                                        break;
                                    case 'ZGCUM':
                                        _this.code = '130';
                                        break;
                                    case 'SARLAFT':
                                        _this.code = '107';
                                        break;
                                    case 'ALTACLIENTE':
                                        _this.code = _this.validationHelperService.isPassiveProduct()
                                            ? '124'
                                            : '125';
                                        break;
                                    case 'ALTAPROD':
                                        _this.code = _this.validationHelperService.isPassiveProduct()
                                            ? '124'
                                            : '125';
                                        break;
                                    case 'TASAS':
                                        _this.code = '107';
                                        break;
                                    case 'ESC':
                                        phase
                                            ? (_this.code = '107')
                                            : (_this.code =
                                                dataPCO.solicitation_status === '12' ? '200' : '129');
                                        break;
                                    case 'NORMALIZACION':
                                        _this.code = '17';
                                        _this.abreCuentasService.setIsNormalizacion(true);
                                        break;
                                    default:
                                        _this.code = '127';
                                        break;
                                }
                            })
                                .catch(function () { return (_this.code = '107'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.code];
                }
            });
        });
    };
    CaptureService.prototype.createObjModelPco = function (productSelected, dataProduct) {
        return {
            product_type: productSelected.product_type,
            limit_amount: {
                currency: dataProduct.available_amount.currency,
                amount: dataProduct.available_amount.amount,
                decimals: dataProduct.available_amount.decimals,
            },
        };
    };
    /**
     * Función para obtener los datos de una solicitud
     *
     * *Function to call pco since bizagi*
     *
     * @type {function}
     * @returns {this.code}
     */
    CaptureService.prototype.getInfoBySolicitationId = function (solicitation_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataPCO;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataPCO = [];
                        return [4 /*yield*/, this.requestService
                                .getChannelNotification(solicitation_id)
                                .then(function (res) {
                                dataPCO = JSON.parse(_this.cipherService.decrypt(res.data.message)).data[0];
                                _this.abreCuentasService.setSolicitationInfo(dataPCO);
                            })
                                .catch(function () { return (dataPCO = []); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, dataPCO];
                }
            });
        });
    };
    /*
     * Función para solicitar las solicitudes
     * @param code
     * @returns
     */
    CaptureService.prototype.getRequestByNumber = function (code, document) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestNumber, resObject;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestNumber = code.toString();
                        resObject = {};
                        return [4 /*yield*/, this.requestService
                                .getChannelNotification(requestNumber)
                                .then(function (res) {
                                var dataRequest = JSON.parse(_this.cipherService.decrypt(res.data.message)).data[0];
                                if (!dataRequest) {
                                    resObject.code = '100';
                                    return resObject;
                                }
                                var docRes;
                                if (dataRequest.prospects[0]) {
                                    resObject.user = dataRequest.prospects[0];
                                    docRes = resObject.user.document.number + "_" + resObject.user.document.type;
                                }
                                if (document !== docRes) {
                                    resObject.code = '100';
                                    return resObject;
                                }
                                if (!dataRequest.solicitation_date_history) {
                                    resObject.code = '142';
                                    return resObject;
                                }
                                // dataRequest.solicitation_status_history = '02-05,03-06,03-07,04-09,10-10';
                                var creditGrayZone = [
                                    '02-05',
                                    '03-06',
                                    '03-07',
                                    '03-08',
                                    '04-05',
                                    '04-09',
                                    '05-05',
                                    '06-05',
                                ];
                                var refused = [
                                    '03-02',
                                    '03-08',
                                    '04-02',
                                    '04-08',
                                    '07-02',
                                    '07-08',
                                    '12-02',
                                    '12-08',
                                ];
                                var complianceGrayZone = ['07-05', '08-06', '09-05'];
                                var isRefused = dataRequest.solicitation_status_history
                                    .split(',')
                                    .some(function (element) { return refused.indexOf(element) >= 0; });
                                var isInCreditGrayZone = dataRequest.solicitation_status_history
                                    .split(',')
                                    .some(function (element) { return creditGrayZone.indexOf(element) >= 0; });
                                var isInComplianceGrayZone = dataRequest.solicitation_status_history
                                    .split(',')
                                    .some(function (element) { return complianceGrayZone.indexOf(element) >= 0; });
                                if (!isInCreditGrayZone && !isInComplianceGrayZone) {
                                    resObject.code = '100';
                                    return resObject;
                                }
                                var oneMonthAgo = new Date();
                                if (oneMonthAgo.getMonth() === 0) {
                                    oneMonthAgo.setFullYear(oneMonthAgo.getFullYear() - 1);
                                    oneMonthAgo.setMonth(11);
                                }
                                else {
                                    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                                }
                                var dateRequest = new Date(dataRequest.solicitation_date_history.split(',')[0]);
                                if (dateRequest < oneMonthAgo) {
                                    resObject.code = '132';
                                    return resObject;
                                }
                                _this.abreCuentasService.setRequestModel(dataRequest);
                                resObject.isRefused = isRefused;
                                resObject.code = '200';
                            })
                                .catch(function (error) {
                                console.error(error);
                                resObject.code = '131';
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, resObject];
                }
            });
        });
    };
    CaptureService.prototype.getRequestsByClient = function (documentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resObject, product_type;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resObject = {};
                        product_type = this.abreCuentasService.getproductSelected().product_type;
                        return [4 /*yield*/, this.requestService
                                .getChannelNotificationClient(documentId, product_type === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT)
                                .then(function (res) {
                                resObject.product = res;
                                var dataRequest = res.data;
                                var visibleSolicitations = [];
                                dataRequest.forEach(function (solicitation) {
                                    // dataRequest.solicitation_status_history = '02-05,03-06,03-07,04-09,10-10';
                                    var creditGrayZone = [
                                        '02-05',
                                        '03-06',
                                        '03-07',
                                        '03-08',
                                        '04-05',
                                        '04-09',
                                        '05-05',
                                        '06-05',
                                    ];
                                    var complianceGrayZone = ['07-05', '08-06', '09-05'];
                                    var isInCreditGrayZone = solicitation.solicitation_status_history
                                        .split(',')
                                        .some(function (element) { return creditGrayZone.indexOf(element) >= 0; });
                                    var isInComplianceGrayZone = solicitation.solicitation_status_history
                                        .split(',')
                                        .some(function (element) { return complianceGrayZone.indexOf(element) >= 0; });
                                    // solicitation.solicitation_date_history = '2022-01-18T10:14:04';
                                    /* istanbul ignore if */
                                    var oneMonthAgo = new Date();
                                    if (oneMonthAgo.getMonth() === 0) {
                                        oneMonthAgo.setFullYear(oneMonthAgo.getFullYear() - 1);
                                        oneMonthAgo.setMonth(11);
                                    }
                                    else {
                                        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                                    }
                                    var dateRequest = new Date();
                                    if (!solicitation.solicitation_date_history) {
                                        dateRequest = new Date('2000-01-01T00:00:00.000');
                                    }
                                    else {
                                        dateRequest = new Date(solicitation.solicitation_date_history.split(',')[0]);
                                    }
                                    if ((isInCreditGrayZone || isInComplianceGrayZone) &&
                                        dateRequest >= oneMonthAgo) {
                                        visibleSolicitations.push(solicitation);
                                    }
                                });
                                resObject.code = '200';
                                resObject.data = visibleSolicitations;
                            })
                                .catch(function (error) {
                                console.error(error);
                                resObject.code = '131';
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, resObject];
                }
            });
        });
    };
    CaptureService.prototype.loadDocument = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resObject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resObject = {};
                        return [4 /*yield*/, this.requestService
                                .loadDocument(body)
                                .then(function (res) {
                                resObject.data = res;
                                resObject.code = '200';
                            })
                                .catch(function (error) {
                                console.error(error);
                                resObject.code = '131';
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, resObject];
                }
            });
        });
    };
    CaptureService.prototype.documentarySufficiency = function (principalActivityId, operationTarget) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resObject;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resObject = {};
                        return [4 /*yield*/, this.requestService
                                .documentarySufficiency(principalActivityId, operationTarget)
                                .then(function (res) {
                                resObject.data = res.data;
                                resObject.code = '200';
                            })
                                .catch(function (error) {
                                console.error(error);
                                resObject.code = '131';
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, resObject];
                }
            });
        });
    };
    CaptureService.prototype.saveBitacora = function (eventName) {
        var devicePrint = new LogDeviceModel();
        var product_name = this.abreCuentasService.getproductSelected()
            ? this.abreCuentasService.getproductSelected().product_code
            : '';
        devicePrint.device = this.abreCuentasService.getDeviceInfo();
        // const ipBiocatch = this.bioCatchService.getCurrentScoreIp();
        devicePrint.device.event_name = eventName;
        // devicePrint.device.ip = ipBiocatch;
        devicePrint.terms_type = eventName;
        this.requestService.saveDataInBitacora(devicePrint);
    };
    CaptureService.prototype.getPcoAmount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productSelected;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productSelected = this.abreCuentasService.getproductSelected();
                        this.saveBitacora('Ini_loading_PCO');
                        return [4 /*yield*/, this.performPco().then(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (result !== '200') {
                                                return [2 /*return*/, '107'];
                                            }
                                            return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO'])];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, this.getChannelComunicator(false, true).then(function (result2) {
                                                    if (result2 === '107' || result2 === '121' || result2 === '130' || result2 === '129' || result2 === '124' || result2 === '127') {
                                                        _this.saveBitacora('Out_loading_PCO');
                                                        return result2;
                                                    }
                                                    if (result2 === '17') {
                                                        _this.saveBitacora('Normalization_yes');
                                                        return ERROR_LIB.CODE;
                                                    }
                                                    else {
                                                        _this.saveBitacora('Out_loading_PCO');
                                                        return result2;
                                                    }
                                                }).catch(function () { return '107'; })];
                                        case 2: return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); }).catch(function (error) {
                                console.log('🚀 ~ file: capture.service.ts:2490 ~ CaptureService ~ awaitthis.performPco ~ error:', error);
                                return '107';
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CaptureService.prototype.formatBirthDate = function (birthDate) {
        var dateFormat = birthDate;
        if (dateFormat.indexOf('/') !== -1) {
            if (dateFormat.split('/')[0].length === 4) {
                birthDate = dateFormat.split('/').join('-');
            }
            else {
                birthDate = dateFormat.split('/').reverse().join('-');
            }
        }
        return birthDate;
    };
    CaptureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CaptureService_Factory() { return new CaptureService(i0.ɵɵinject(i1.RequestService), i0.ɵɵinject(i2.AbreCuentasService), i0.ɵɵinject(i3.ValidationHelperService), i0.ɵɵinject(i4.HelpersService), i0.ɵɵinject(i5.StringHelperService), i0.ɵɵinject(i6.FirmlyApprovedService), i0.ɵɵinject(i7.ParametersService), i0.ɵɵinject(i8.ChannelCommunicatorService), i0.ɵɵinject(i8.ChannelCommunicatorService), i0.ɵɵinject(i9.CryptoVaultService)); }, token: CaptureService, providedIn: "root" });
    return CaptureService;
}());
export { CaptureService };
